const parseQueryParamsToObject = (urlQueryParam: string) => {
  // get string 'tab=rooms' from '/en/h/N03RKMK?tab=rooms' or '?tab=rooms' or 'tab=rooms'
  const params = urlQueryParam.split('?');
  const paramStr = params.length > 1 ? params[1] : params[0];

  // create object like { tab: 'room' }
  const newQueryParams: Record<string, string> = {};
  const searchParams = new URLSearchParams(paramStr);
  searchParams.forEach((value, key) => {
    newQueryParams[key] = value;
  });
  return newQueryParams;
};

export default parseQueryParamsToObject;
